module.exports = __webpack_public_path__ + "media/Video (23).1dfb24ed.mp4";